import React, { useState } from "react";
import CheckBox from "../../sharedComponents/checkbox/checkbox";
import Button from "../../sharedComponents/buttons/button";
import Lang from "../../../userPreferences/staticWords";
const PageThree = ({
  setPages,
  setPageThreeData,
  pageThreeData,
  isFinished,
}) => {
  const [one, setOne] = useState(pageThreeData.one ?? false);
  const [two, setTwo] = useState(pageThreeData.two ?? false);
  const [three, setThree] = useState(pageThreeData.three ?? false);
  const [four, setFour] = useState(pageThreeData.four ?? false);
  const [five, setFive] = useState(pageThreeData.five ?? false);
  const [six, setSix] = useState(pageThreeData.six ?? false);

  const Data = {
    one,
    two,
    three,
    four,
    five,
    six,
  };
  const handleChange = (
    setValue,
    setData,
    value,
    currentField,
    data,
    UpdateData
  ) => {
    setValue(value);
    if (UpdateData) UpdateData(setData, data, currentField, value);
  };
  const updateParent = (setData, data, currentField, value) => {
    const myData = data;
    myData[currentField] = value;
    setData(myData);
  };
  const prevRender = () => {
    setPageThreeData(Data);
    setPages({ one: false, two: true, three: false });
  };
  return (
    <>
      <div className="col-12 col-md-8 px-2">{Lang.registerStatement} </div>
      <div className="d-flex col-12 col-md-8 my-2">
        <CheckBox
          checked={one}
          value={"one"}
          onChange={(e) => {
            const { checked, value } = e.target;
            handleChange(
              setOne,
              setPageThreeData,
              checked,
              value,
              Data,
              updateParent
            );
          }}
        />
        <div>
          <div>{Lang.inputone}</div>
        </div>
      </div>

      <div className="d-flex col-12 col-md-8 my-2">
        <CheckBox
          checked={two}
          value={"two"}
          onChange={(e) => {
            const { checked, value } = e.target;
            handleChange(
              setTwo,
              setPageThreeData,
              checked,
              value,
              Data,
              updateParent
            );
          }}
        />
        <div>{Lang.inputtwo}</div>
      </div>
      <div className="d-flex col-12 col-md-8 my-2">
        <CheckBox
          checked={three}
          value={"three"}
          onChange={(e) => {
            const { checked, value } = e.target;
            handleChange(
              setThree,
              setPageThreeData,
              checked,
              value,
              Data,
              updateParent
            );
          }}
        />
        <div>{Lang.inputthree}</div>
      </div>
      <div className="d-flex col-12 col-md-8 my-2">
        <CheckBox
          color={isFinished && !four ? "#dc3545" : null}
          checked={four}
          value={"four"}
          onChange={(e) => {
            const { checked, value } = e.target;
            handleChange(
              setFour,
              setPageThreeData,
              checked,
              value,
              Data,
              updateParent
            );
          }}
        />
        <div>{Lang.inputfour}</div>
      </div>
      <div className="d-flex col-12 col-md-8 my-2">
        <CheckBox
          color={isFinished && !five ? "#dc3545" : null}
          checked={five}
          value={"five"}
          require={true}
          onChange={(e) => {
            const { checked, value } = e.target;
            handleChange(
              setFive,
              setPageThreeData,
              checked,
              value,
              Data,
              updateParent
            );
          }}
        />
        <div>{Lang.inputfive}</div>
      </div>
      <div className="d-flex col-12 col-md-8 my-2">
        <CheckBox
          color={isFinished && !six ? "#dc3545" : null}
          checked={six}
          value={"six"}
          require={true}
          onChange={(e) => {
            const { checked, value } = e.target;
            handleChange(
              setSix,
              setPageThreeData,
              checked,
              value,
              Data,
              updateParent
            );
          }}
        />
        <div>{Lang.inputsix}</div>
      </div>
      <div className="d-flex justify-content-center col-12 ">
        <Button
          content={Lang.prevButton}
          onClick={prevRender}
          containerStyle={"col-3 mx-3 mt-2"}
        />
      </div>
    </>
  );
};

export default PageThree;
